// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"79":"6a8c0d62","305":"6a8c0d62","417":"6a8c0d62","461":"6a8c0d62","467":"344467aa","832":"1c75925f","927":"6a8c0d62"}[chunkId] + ".chunk.css";
};